module.exports = __webpack_public_path__ + "static/media/ic_reject.11720cfd.svg";